interface FeatureHighlightProps {
  Icon: (props: React.ComponentProps<"svg">) => JSX.Element;
  title: string;
  description: string;
}

export const FeatureHighlight = ({
  Icon,
  title,
  description,
}: FeatureHighlightProps) => {
  return (
    <div className="flex gap-x-20">
      <Icon className="mt-4 h-24 w-24 shrink-0" />
      <div className="flex flex-col gap-y-4">
        <div className="text-14-16 font-bold text-gray-900 sm:text-16-24">
          {title}
        </div>
        <div className="text-13-20 text-gray-700 sm:text-14-16">
          {description}
        </div>
      </div>
    </div>
  );
};
